import { render, staticRenderFns } from "./DesignGridLayout.vue?vue&type=template&id=8ed63f28&scoped=true&"
import script from "./DesignGridLayout.vue?vue&type=script&lang=js&"
export * from "./DesignGridLayout.vue?vue&type=script&lang=js&"
import style0 from "./DesignGridLayout.vue?vue&type=style&index=0&id=8ed63f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed63f28",
  null
  
)

export default component.exports